import React from 'react';
import {
    Grid,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import GaugeChart from 'react-gauge-chart';
import classNames from 'classnames';

const styles = (theme) => ({
    gaugeContainer: {
        width: 100,
        marginTop: -6,
    },
    creditScore: {
        fontWeight: 700,
        textAlign: 'center',
        height: 26,
        backgroundColor: '#ff0000',
        borderRadius: 4,
        width: 50,
        paddingTop: 5,
        fontSize: 14,
    },
    gaugeGreen: {
        color: '#ffffff',
        backgroundColor: '#00ff00',
    },
    gaugeAmber: {
        color: '#ffffff',
        backgroundColor: '#FFBF00',
    },
    gaugeRed: {
        color: '#ffffff',
        backgroundColor: '#ff0000',
    },
    creditScoreContainer: {
        width: 200,
    },
    creditScoreValue: {
        float: 'left',
        width: 75,
    },
    creditScoreChild: {
        float: 'left',
        width: 100,
    },
    na: {
        textAlign: 'left',
    },
});

class ContactBadges extends React.Component {
    state = {
    };

    render() {
        const {
            classes,
            creditScore,
            reference,
            type,
        } = this.props;

        return (
            <div className={classes.gaugeContainer}>
                {!creditScore
                    ? (
                        <div className={classes.na}>
                            n/a
                        </div>
                    )
                    : (
                        <div className={classes.creditScoreContainer}>

                            <div className={classes.creditScoreValue}>

                                <div className={classNames(
                                    classes.creditScore,
                                    {
                                        [classes.gaugeRed]: creditScore < 450,
                                    },
                                    {
                                        [classes.gaugeAmber]: (creditScore >= 450 && creditScore < 600),
                                    },
                                    {
                                        [classes.gaugeGreen]: creditScore >= 600,
                                    },
                                )}
                                >
                                    {creditScore}
                                </div>
                            </div>

                            {/* <div className={classes.creditScoreChild}>
                                <div>
                                    <GaugeChart
                                        id={`gauge-chart-${reference}`}
                                        arcsLength={[45, 15, 40]}
                                        cornerRadius={1}
                                        hideText
                                        nrOfLevels={3}
                                        style={{ height: 70 }}
                                        percent={(creditScore / 1000)}
                                        colors={[
                                            '#ff0000',
                                            '#FFBF00',
                                            '#00ff00',
                                        ]}
                                    />
                                </div>
                            </div> */}

                        </div>
                    )}
            </div>
        );
    }
}

export default withStyles(styles)(ContactBadges);
